/* Sop. Essential · Configurador Kit AM6 · parte 3 de 4: pintado y vista previa (requiere sop-kit.js) */
(function () {
  'use strict';
  var S = window.SopKit, Kit = S.Kit, STEPS = S.STEPS, STEP_NAMES = S.STEP_NAMES, esc = S.esc, fmt = S.fmt;

  // Dibujos de tapa: los mismos del configurador de la tapa (assets configurador-*.js)
  var TPL_FILES = {
    // [archivo, variable, zona negra dentro del aro: cx, cy, radio] — los logos no pasan de ese círculo
    v2: ['configurador-product-v2.js', 'PRODUCT_V2', [455, 407, 238]],
    rotor1: ['configurador-rotor1.js', 'PRODUCT_ROTOR1', [446, 422, 320]],
    rotor4: ['configurador-rotor4.js', 'PRODUCT_ROTOR4', [463, 449, 323]],
    rotor5: ['configurador-rotor5.js', 'PRODUCT_ROTOR5', [481, 446, 339]],
    rotor6: ['configurador-rotor6.js', 'PRODUCT_ROTOR6', [455, 433, 292]],
    rotor62: ['configurador-rotor62.js', 'PRODUCT_ROTOR62', [455, 433, 292]],
    rotor10: ['configurador-rotor10.js', 'PRODUCT_ROTOR10', [581, 464, 336]]
  };
  // Logos con dibujo en configurador-logo-data.js (nombre → clave en LOGO_DATA)
  var LOGO_KEYS = {
    '2fast': '2fast-4a9d8b26', '2win': '2win', 'airsal': 'Airsal', 'allpro': 'Allpro', 'bando boys': 'Bando-boys',
    'beta': 'Beta', 'bikelife': 'Bikelife', 'castrol': 'Casstrol', 'corona': 'Corona', 'corona ii': 'Corona-2',
    'diamante': 'Diamante', 'estrellas s6': 'Estrelles_stage_6', 'gorilla': '4_rgb_gorilla__1_', 'krm': 'Krm',
    'malossi': 'Malossi', 'most llarg': 'Most_llarg', 'motul': 'Motul', 'mrt': 'Mrt', 'redbull': 'Redbull',
    'redbull toros': 'Redbull_toros', 'rieju': 'Rieju', 'rieju smx': 'Rieju-smx', 'scootfast': 'Scootfast',
    'scootfast full': 'Scootfast_completo', 'scootfast letras': 'Scootfast_letras', 'sherco': 'Sherco', 'sop': 'Sop',
    'stage 6': 'Stage_6', 'tiburón': 'Tiburon', 'tiburon': 'Tiburon', 'tpr': 'Tpr', 'vespa': 'Vespa', 'voca': 'Voca', 'yasuni': 'Yasuni'
  };
  var FONT = ' font-family="Archivo, sans-serif" font-weight="700"';

  var scriptCache = {};
  function loadScript(file) {
    if (!scriptCache[file]) {
      scriptCache[file] = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = file; s.async = true; s.onload = resolve; s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    return scriptCache[file];
  }
  S.loadScript = loadScript;
  S.TPL_FILES = TPL_FILES;

  Kit.prototype.ensureLogoData = function () {
    if (window.LOGO_DATA) return Promise.resolve();
    var self = this;
    return loadScript(this.data.assetBase + 'configurador-logo-data.js').then(function () { self.previewKey = null; self.render(); }, function () {});
  };
  Kit.prototype.logoData = function (name) {
    if (!window.LOGO_DATA || !name) return null;
    var key = LOGO_KEYS[String(name).trim().toLowerCase()];
    return (key && window.LOGO_DATA[key]) || window.LOGO_DATA[name] || null;
  };
  Kit.prototype.logoThumb = function (name) {
    var d = this.logoData(name);
    if (!d) return '<span class="sk-thumb-txt">' + esc(String(name).slice(0, 3)) + '</span>';
    return '<svg viewBox="' + d.bb.join(' ') + '" aria-hidden="true"><g transform="' + d.it + '"><path d="' + d.off +
      '" fill="var(--c-details)"/>' + (d.lo ? '<path d="' + d.lo + '" fill="var(--c-letters)"/>' : '') + '</g></svg>';
  };

  // Ancho real de un texto en Archivo 700 (para que nunca se salga de su hueco)
  var ctx2d = null;
  function textWidth(t, fs) {
    try {
      ctx2d = ctx2d || document.createElement('canvas').getContext('2d');
      ctx2d.font = '700 ' + fs + 'px Archivo, sans-serif';
      return ctx2d.measureText(t).width;
    } catch (e) { return t.length * fs * 0.62; }
  }
  function pathLength(d) {
    try { var el = document.createElementNS('http://www.w3.org/2000/svg', 'path'); el.setAttribute('d', d); return el.getTotalLength(); } catch (e) { return 0; }
  }

  // Logo o texto encajado en un hueco {x,y,w,h}. "grow" deja crecer en alto los logos altos (no los textos).
  // En las tapas "f" trae el mapa de la base (f.mask): el logo o texto nunca pisa detalles, letras ni agujeros.
  Kit.prototype.slotSvg = function (slot, val, grow, f) {
    if (!slot || !val || !val.value) return '';
    var cx = slot.x + slot.w / 2, cy = slot.y + slot.h / 2, fit, ring = f && f.ring, mask = f && f.mask;
    var open = slot.transform ? '<g transform="' + slot.transform + '">' : '<g>';
    var d = val.type === 'logo' && this.logoData(val.value);
    if (d) {
      var bw = d.bb[2], bh = d.bb[3], kMax = Math.min(slot.w * 0.9 / bw, slot.h * (grow || 1) * 0.9 / bh);
      fit = mask ? S.baseFit(mask, slot, S.logoPts(d), 1, kMax) : S.ringFit(slot, ring, bw / 2, bh / 2, kMax);
      var sc = fit.k;
      cx += fit.dx; cy += fit.dy;
      var tx = -((d.bb[0] + bw / 2) * sc), ty = -((d.bb[1] + bh / 2) * sc);
      return open + '<g transform="translate(' + cx + ' ' + cy + ') translate(' + tx + ' ' + ty + ') scale(' + sc + ')"><g transform="' + d.it +
        '"><path d="' + d.off + '" fill="var(--c-details)"/>' + (d.lo ? '<path d="' + d.lo + '" fill="var(--c-letters)"/>' : '') + '</g></g></g>';
    }
    var text = val.type === 'req' ? '?' : String(val.value).trim();
    var fs = slot.h * 0.8, room = slot.w * 0.92, nat = textWidth(text, fs) + fs * 0.1, tw = Math.min(nat, room), r;
    if (mask) { fit = S.baseFit(mask, slot, S.textPts(text, textWidth(text, 100)), tw / nat, fs / 100); r = fit.k * 100 / fs; }
    else { fit = S.ringFit(slot, ring, tw / 2, fs * 0.38, 1); r = fit.k; }
    fs *= r; room *= r; cx += fit.dx; cy += fit.dy;
    fit = textWidth(text, fs) + fs * 0.1 > room ? ' textLength="' + room + '" lengthAdjust="spacingAndGlyphs"' : '';
    return open + '<text x="' + cx + '" y="' + cy + '" text-anchor="middle" dominant-baseline="central" fill="var(--c-letters)" stroke="var(--c-details)"' +
      ' stroke-width="' + (fs * 0.08) + '" paint-order="stroke"' + FONT + ' font-size="' + fs + '"' + fit + '>' + esc(text) + '</text></g>';
  };

  Kit.prototype.coverSvg = function (p, withContent) {
    var s = this.state, slots = p.slots || {}, extra = '';
    if (withContent) {
      // Un logo alto en el centro aprovecha el disco: mucho si arriba y abajo están vacíos, un poco si no
      var self = this, free = !s.top && !s.bottom;
      var f = { ring: S.ringOf(p), mask: S.baseMask(p, function () { self.previewKey = null; self.render(); }) };
      extra = this.slotSvg(slots.top, s.top, 1.15, f) + this.slotSvg(slots.center, s.center, free ? 4.2 : 1.3, f) + this.slotSvg(slots.bottom, s.bottom, 1.15, f);
      var ig = this.clean(s.igTapa);
      if (s.igOn === 'SÍ' && ig && p.instagramSlot) {
        var sl = p.instagramSlot, txt = '@' + ig, fs = (sl.fontSize || 22) * 1.9, id = this.uid + '-ig';
        if (p.skIgLen == null) p.skIgLen = pathLength(sl.pathD) || (sl.maxTextLength || 290) * 1.3;
        var max = p.skIgLen * 0.96;
        extra += '<defs><path id="' + id + '" d="' + sl.pathD + '" fill="none"/></defs><text fill="var(--c-letters)"' + FONT + ' font-size="' + fs + '"' +
          (textWidth(txt, fs) > max ? ' textLength="' + max + '" lengthAdjust="spacingAndGlyphs"' : '') +
          '><textPath href="#' + id + '" startOffset="50%" text-anchor="middle">' + esc(txt) + '</textPath></text>';
      }
    }
    var body = p.rawSvg || (p.baseSvg || '') + (p.overlaySvg || '');
    return '<svg class="sk-cover" viewBox="' + p.viewBox + '" role="img" aria-label="Tapa de encendido">' + body + extra + '</svg>';
  };

  /* ---------------- render ---------------- */

  Kit.prototype.render = function () {
    var self = this, s = this.state, root = this.root;
    var v = this.currentVariant(), missing = this.missing();

    ['base', 'det', 'let'].forEach(function (k) {
      root.style.setProperty(k === 'base' ? '--c-base' : k === 'det' ? '--c-details' : '--c-letters', self.hex(k));
      var c = s[k], lab = self.$('[data-val="' + k + '"]');
      if (lab) lab.textContent = c ? (c.custom ? c.hex : c.name) : '';
      var pk = self.$('[data-picker="' + k + '"]');
      pk.hidden = !(c && c.custom);
      if (c && c.custom) {
        pk.querySelector('[data-pk-swatch]').style.background = c.hex;
        pk.querySelector('[data-pk-hex]').textContent = c.hex;
        ['h', 's', 'l'].forEach(function (x) { var r = pk.querySelector('[data-pk="' + x + '"]'); if (+r.value !== c[x]) r.value = c[x]; });
        pk.querySelector('[data-pk="s"]').style.background = 'linear-gradient(90deg,hsl(' + c.h + ',0%,' + c.l + '%),hsl(' + c.h + ',100%,' + c.l + '%))';
        pk.querySelector('[data-pk="l"]').style.background = 'linear-gradient(90deg,#000,hsl(' + c.h + ',' + c.s + '%,50%),#fff)';
      }
    });

    var extras = this.selectedExtras();
    var extrasSum = extras.reduce(function (a, e) { return a + e.price; }, 0);
    this.$('[data-sk-price]').textContent = fmt(v.price);
    var cmp = this.$('[data-sk-compare]');
    cmp.hidden = !(v.compare > v.price);
    if (!cmp.hidden) cmp.textContent = fmt(v.compare);
    this.$('[data-sk-bar-price]').textContent = fmt(v.price + extrasSum);

    this.$$('[data-opt]').forEach(function (input) {
      var opts = s.opts.slice();
      opts[+input.dataset.opt] = input.value;
      var alt = self.variantFor(opts), d = alt ? alt.price - v.price : 0;
      input.parentNode.querySelector('[data-diff]').textContent = !alt ? 'No disponible' : d > 0 ? '+' + fmt(d) : d < 0 ? '−' + fmt(-d) : '';
      input.disabled = !alt || !alt.available;
    });

    this.$$('[data-ppanel]').forEach(function (p) { p.hidden = p.dataset.ppanel !== s.ptype; });
    this.$('[data-count="ptext"]').textContent = s.ptext.length + '/6';
    ['top', 'center', 'bottom', 'pinon'].forEach(function (k) {
      var x = k === 'pinon' ? s.plogo : s[k], pick = self.$('[data-pick="' + k + '"]');
      var on = !!(x && x.type !== 'text');
      pick.classList.toggle('is-on', on);
      pick.querySelector('[data-pick-label]').textContent = !on ? (k === 'pinon' ? 'Elegir logo o pedir un dibujo' : 'Elegir logo') : (x.type === 'req' ? 'A buscar: ' : '') + x.value;
      pick.querySelector('[data-pick-thumb]').innerHTML = on ? (x.type === 'req' ? '<span class="sk-thumb-txt">?</span>' : self.logoThumb(x.value)) : '';
      if (k === 'pinon') return;
      self.$('[data-count="' + k + '"]').textContent = self.$('[data-text="' + k + '"]').value.length + '/10';
      var clear = self.$('[data-clear="' + k + '"]');
      if (clear) clear.hidden = !x;
    });

    var yes = s.igOn === 'SÍ';
    this.$('[data-ig-tapa-wrap]').hidden = !yes;
    this.$('[data-ig-same-wrap]').hidden = !yes;
    this.$('[data-ig-contact-wrap]').hidden = yes && s.igSame;

    this.$$('[data-goto]').forEach(function (b) {
      var n = +b.dataset.goto;
      b.classList.toggle('is-done', n < STEPS ? self.stepMissing(n).length === 0 : missing.length === 0);
      b.classList.toggle('is-current', n === self.step);
      if (n === self.step) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
    });
    var total = 9 + (yes ? 1 : 0) - (yes && s.igSame ? 1 : 0);
    var pct = Math.round(((total - missing.length) / total) * 100);
    var prog = this.$('[data-sk-progress]');
    prog.setAttribute('aria-valuenow', pct);
    prog.firstElementChild.style.width = pct + '%';

    var nextBtn = this.$('[data-sk-next]'), status = this.$('[data-sk-status]');
    this.$('[data-sk-prev]').hidden = this.step === 1;
    var last = this.step === STEPS;
    nextBtn.textContent = last ? 'Añadir al carrito' : 'Siguiente: ' + STEP_NAMES[this.step + 1];
    nextBtn.classList.toggle('is-off', last && missing.length > 0);
    if (last && missing.length) nextBtn.setAttribute('aria-disabled', 'true'); else nextBtn.removeAttribute('aria-disabled');
    if (missing.length) {
      status.textContent = 'Te falta: ' + missing.slice(0, 2).map(function (m) { return m.label; }).join(', ') + (missing.length > 2 ? ' y ' + (missing.length - 2) + ' más' : '');
      status.classList.remove('is-ok');
    } else {
      status.textContent = this.data.readyText || 'Todo listo.';
      status.classList.add('is-ok');
    }

    this.renderSummary();
    this.renderShipping(v.price + extrasSum);
    this.renderPreview();
  };

  // Coloca un <svg> dentro de otro en la caja b, recortado a su dibujo real (b.vb)
  function nest(svg, b) {
    return svg.replace(/viewBox="[^"]*"/, 'viewBox="' + b.vb + '"').replace('<svg ', '<svg x="' + b.x + '" y="' + b.y + '" width="' + b.w + '" height="' + b.h + '" ');
  }

  // Tapa y piñón en un solo dibujo, siempre al mismo tamaño y sitio para todos los modelos (S.kitLayout).
  Kit.prototype.renderPreview = function () {
    var self = this, s = this.state, prev = this.$('[data-sk-preview]'), tapa = this.$('[data-sk-tapa]');
    var d = this.designObj(), tpl = d && TPL_FILES[d.tpl], p = tpl && window[tpl[1]];
    var showPinon = !!s.pmodel || this.step >= 2;
    if (tpl && !p) {
      tapa.classList.add('is-loading');
      if (this.waiting !== tpl[0]) {
        this.waiting = tpl[0];
        loadScript(this.data.assetBase + tpl[0]).then(function () { self.waiting = null; self.render(); }, function () {});
      }
    }
    if (!p) {
      if (!tpl && this.layoutKey !== 'img') {
        this.layoutKey = 'img';
        tapa.innerHTML = '<img class="sk-preview__img" src="' + esc(this.data.fallbackImg) + '" alt="Kit AM6 personalizado">';
      }
    } else {
      var idx = this.pinonIndex(), cb = function () { self.render(); };
      var model = showPinon ? this.pinonModel(idx, cb) : null;
      var layout = s.design + '|' + (model ? model.viewBox : '-');
      if (this.layoutKey !== layout) {
        this.layoutKey = layout;
        this.previewKey = null;
        var L = S.kitLayout(p, model);
        this.boxT = L.t; this.boxP = L.p; this.kitVb = L.vb;
        tapa.innerHTML = '<svg class="sk-kit" viewBox="' + L.vb + '" role="img" aria-label="Vista previa de tu kit">' +
          '<g data-kit-tapa></g>' + (model ? '<g data-kit-pin></g>' : '') + '</svg>';
      }
      if (['top', 'center', 'bottom'].some(function (k) { return s[k] && s[k].type === 'logo'; })) this.ensureLogoData();
      var key = JSON.stringify([s.design, s.top, s.center, s.bottom, s.igOn, s.igTapa, !!window.LOGO_DATA]);
      if (this.previewKey !== key) {
        this.previewKey = key;
        tapa.querySelector('[data-kit-tapa]').innerHTML = nest(this.coverSvg(p, true), this.boxT);
      }
      if (model) {
        var pe = this.pinonEntry();
        if (pe && pe.logo) this.ensureLogoData();
        tapa.querySelector('[data-kit-pin]').innerHTML = nest(this.pinonSvg(idx, pe, cb), this.boxP);
      }
      // Logos: zoom al aro de la tapa. Instagram: la tapa entera. Sin el piñón en los dos.
      var kit = tapa.querySelector('svg.sk-kit'), bt = this.boxT, ring = S.ringOf(p), bb = p.skBox, z = null;
      if (bt && this.step === 5) z = [bt.x, bt.y, bt.w, bt.h];
      if (bt && this.step === 4 && ring && bb) {
        var k = bt.h / bb[3], R = ring[2] * 1.1 * k;
        z = [bt.x + (ring[0] - bb[0]) * k - R, bt.y + (ring[1] - bb[1]) * k - R, 2 * R, 2 * R];
      }
      if (kit) kit.setAttribute('viewBox', z ? z.join(' ') : this.kitVb);
      prev.classList.toggle('is-zoom', !!z);
      tapa.classList.remove('is-loading');
    }
    prev.classList.toggle('focus-pinon', !!p && showPinon && this.step === 2);
    prev.classList.toggle('is-galaxy', /galaxy/i.test(s.opts.join(' ')));
    this.$('[data-sk-chips]').innerHTML = ['base', 'det', 'let'].filter(function (k) { return s[k]; }).map(function (k) {
      return '<li><i style="background:' + self.hex(k) + '"></i>' + esc(s[k].custom ? s[k].hex : s[k].name) + '</li>';
    }).join('');
  };
})();